
import Vue from "vue";
import AuthLayout from "@/layout/AuthLayout.vue";
import LoginForm from "../components/LoginForm.vue";

export default Vue.extend({
  name: "loginFormContainer",
  components: {
    AuthLayout,
    LoginForm,
  },
});
